import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, Event, NavigationEnd} from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private currentNav: INavigationData = null;
  private currentNavPromise = new BehaviorSubject<INavigationData>(this.currentNav);
  public $currentNav = this.currentNavPromise.asObservable();

  constructor(private titleService:Title,private metaService:Meta,private router: Router) {
    this.navigation();
  }
  navigation(){
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        let url = event.url;
        if (url) {
          const navData: INavigationData = {
            route: url.replace('/', ''),
            routeType: 1
          }
          sessionStorage.setItem('previousUrl',window.location.href)
          switch (navData.route) {
            case "user/dashboard": {
              navData.routeType = 0;
              this.titleService.setTitle('Dashboard');
              this.metaService.updateTag({ name: 'description', content: 'To View All Insightful Charts and Reports.' });
              break;
            }
            case "user/search/application": {
              navData.routeType = 1;
              this.titleService.setTitle('Freight Audit');
              this.metaService.updateTag({ name: 'description', content: 'To View All Insightful Charts and Reports.' });
              break;
            }
            case "user/search/document-grid": {
              navData.routeType = 2;
              this.titleService.setTitle('Freight Audit');
              break;
            }
            case "user/search/upload-document": {
              navData.routeType = 3;
              this.titleService.setTitle('Upload Document');
              break;
            }
            case "user/profile/overview": {
              navData.routeType = 4;
              this.titleService.setTitle('User Profile');
              this.metaService.updateTag({ name: 'description', content: 'To View User Profile.' });
              break;
            }
            case "user/admin/user-management": {
              navData.routeType = 20;
              this.titleService.setTitle('User Management');
              break;
            }
            case "user/admin/role-management": {
              navData.routeType = 21;
              this.titleService.setTitle('Role Management');
              break;
            }
            case "user/admin/company-management": {
              navData.routeType = 22;
              this.titleService.setTitle('Company Management');
              break;
            }
            case "user/admin/column-settings": {
              navData.routeType = 23;
              this.titleService.setTitle('Column Settings');
              break;
            }
            case "user/admin/document-type": {
              navData.routeType = 25;
              this.titleService.setTitle('Document Type Management');
              break;
            }
            case "user/admin/announcement": {
              navData.routeType = 35;
              this.titleService.setTitle('System Announcement Config');
              break;
            }
            case "user/master-data/business-unit": {
              navData.routeType = 40;
              this.titleService.setTitle('Business Unit');
              break;
            }
            case "user/master-data/country": {
              navData.routeType = 41;
              this.titleService.setTitle('Country Management');
              break;
            }
            case "user/master-data/po": {
              navData.routeType = 42;
              this.titleService.setTitle('PO Management');
              break;
            }
            case "user/master-data/shipment": {
              navData.routeType = 43;
              this.titleService.setTitle('Shipment Management');
              break;
            }
            case "user/master-data/rateCard": {
              navData.routeType = 44;
              this.titleService.setTitle('Rate Card Management');
              break;
            }
            case "user/master-data/contract": {
              navData.routeType = 45;
              this.titleService.setTitle('Contract Management');
              break;
            }
            case "user/master-data/currency-management": {
              navData.routeType = 46;
              this.titleService.setTitle('Currency Management');
              break;
            }
            case "user/admin/charge-sheet": {
              navData.routeType = 47;
              this.titleService.setTitle('Rate Sheet');
              break;
            }
            case "user/admin/billing": {
              navData.routeType = 48;
              this.titleService.setTitle('Billing');
              break;
            }
            case "user/master-data/bre": {
              navData.routeType = 49;
              this.titleService.setTitle('Bre Config');
              break;
            }
            case "user/admin/file-type": {
              navData.routeType = 50;
              this.titleService.setTitle('File Type Management');
              break;
            }
            case "user/master-data/currency-exchange": {
              navData.routeType = 51;
              this.titleService.setTitle('Currency Exchange');
              break;
            }
            case "user/admin/application-config": {
              navData.routeType = 55;
              this.titleService.setTitle('Application Integration Config');
              break;
            }
            case "user/admin/retention-policy": {
              navData.routeType = 60;
              this.titleService.setTitle('Retention Policy Config');
              break;
            }
            case "user/admin/user-activity": {
              navData.routeType = 65;
              this.titleService.setTitle('User Activity Logs');
              break;
            }
            case "user/admin/connectivity": {
              navData.routeType = 70;
              this.titleService.setTitle('Connectivity');
              break;
            }
            case "user/admin/auto-email-template": {
              navData.routeType = 75;
              this.titleService.setTitle('Auto Email Template');
              break;
            }
            case "user/admin/manual-email-template": {
              navData.routeType = 80;
              this.titleService.setTitle('Manual Email Template');
              break;
            }
            case "user/master-data/city-alias": {
              navData.routeType = 81;
              this.titleService.setTitle('City Alias');
              break;
            }
            case "user/master-data/companyName-alias": {
              navData.routeType = 82;
              this.titleService.setTitle('Company Name Alias');
              break;
            }
            case "user/master-data/zip-alias": {
              navData.routeType = 83;
              this.titleService.setTitle('Zip Alias');
              break;
            }
            case "user/master-data/currency-alias": {
              navData.routeType = 84;
              this.titleService.setTitle('Currency Alias');
              break;
            }
            case "user/master-data/vat-alias": {
              navData.routeType = 86;
              this.titleService.setTitle('Vat Alias');
              break;
            }
            case "user/admin/error-code": {
              navData.routeType = 87;
              this.titleService.setTitle('Error Code');
              break;
            }
            case "user/admin/docstatus-management": {
              navData.routeType = 88;
              this.titleService.setTitle('Document Status');
              break;
            }
            case "user/master-data/charge-type": {
              navData.routeType = 89;
              this.titleService.setTitle('Charge Type');
              break;
            }
            case "user/super-admin/client": {
              navData.routeType = 100;
              this.titleService.setTitle('Client Management');
              break;
            }
            case "user/admin/customer-management": {
              navData.routeType = 101;
              this.titleService.setTitle('Customer Management');
              break;
            }
            case "user/admin/vendor-management": {
              navData.routeType = 102;
              this.titleService.setTitle('Vendor Management');
              break;
            }
            case "user/master-data/uom-management": {
              navData.routeType = 103;
              this.titleService.setTitle('UOM Management');
              break;
            }
            case "user/master-data/sector-management": {
              navData.routeType = 104;
              this.titleService.setTitle('Sector Management');
              break;
            }
            case "user/master-data/rules/": {
              navData.routeType = 105;
              this.titleService.setTitle('BRE Config');
              break;
            }
            case "user/master-data/customer-management/": {
              navData.routeType = 109;
              this.titleService.setTitle('Customer SBU Management');
              break;
            }
            case "user/master-data/customer-sbu-management/": {
              navData.routeType = 110;
              this.titleService.setTitle('Customer SBU Management');
              break;
            }
            case "user/admin/billing-details": {
              navData.routeType = 200;
              this.titleService.setTitle('Billing Management');
              break;
            }
            default: {
              navData.routeType = 10000000;
              this.titleService.setTitle('Freight Audit');
              this.metaService.updateTag({ name: 'description', content: 'Welcome to our Portal! Explore our features and services.' });
            }
          }
          if(navData.route){
            if(navData?.route?.includes('user/search/upload-document')){
              navData.routeType = 3;
              this.titleService.setTitle('Upload Document');
            }
            if(navData?.route?.includes('user/search/document-viewer/')){
              navData.routeType = 5;
            }
            if(navData?.route?.includes('user/master-data/po-item/')){
              navData.routeType = 52;
              this.titleService.setTitle('PO Item Management');
            }
            if(navData?.route?.includes('user/admin/email-template-controller')){
              navData.routeType = 85;
              this.titleService.setTitle('Email Template Controller');
            }
            if(navData?.route?.includes('user/master-data/rules/')){
              navData.routeType = 105;
              this.titleService.setTitle('Rules Settings');
            }
            if(navData?.route?.includes('user/admin/carrier-lsp')){
              navData.routeType = 106;
              this.titleService.setTitle('CARRIER/LSP MANAGEMENT');
            }
          }
          this.currentNav = navData;
          this.currentNavPromise.next(navData);
        }
      }

    });
  }
}

export interface INavigationData {
  route: string;
  routeType: number;
}
